import { render, staticRenderFns } from "./formResponseComment.vue?vue&type=template&id=0c86a225&"
import script from "./formResponseComment.vue?vue&type=script&lang=js&"
export * from "./formResponseComment.vue?vue&type=script&lang=js&"
import style0 from "./formResponseComment.vue?vue&type=style&index=0&id=0c86a225&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports